import Vue from 'vue'
import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import CSNTUI from 'cs-nt-ui'
import axios from 'axios'
import 'cs-nt-ui/lib/cs-nt-ui.css'
import 'cs-nt-ui/theme/element/index.css'
import 'cs-nt-ui/theme/cpsp/basalSkin.css'
import './permission' // permission control
import moment from 'moment'
import echarts from 'echarts'
import Video from 'video.js'
import 'video.js/dist/video-js.css'
import vueFilter from '@/utils/filter.js'

Vue.use(ElementUI, { size: 'mini', zIndex: 4000 })
Vue.prototype.$video = Video
Vue.prototype.$echarts = echarts

Vue.use(CSNTUI)
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$moment = moment

for (const key in vueFilter) {
  Vue.filter(key, vueFilter[key])
}
Vue.filter('auditState', function (val) {
  if (val == 'AUDIT_EXEMPT') {
    return '免审核'
  } else if (val == 'AUDIT_NON') {
    return '未审核'
  } else if (val == 'AUDIT_ING') {
    return '待初审'
  } else if (val == 'AUDIT_PASS') {
    return '初审通过'
  } else if (val == 'AUDIT_NO_PASS') {
    return '初审驳回'
  } else if (val == 'RE_AUDIT_ING') {
    return '待复审'
  } else if (val == 'RE_AUDIT_PASS') {
    return '复审通过'
  } else if (val == 'RE_AUDIT_NO_PASS') {
    return '复审驳回'
  } else if (val == 'UNIFORM_AUDIT_NON') {
    return '待终审'
  } else if (val == 'UNIFORM_AUDIT_ING') {
    return '终审中'
  } else if (val == 'UNIFORM_AUDIT_PASS') {
    return '终审通过'
  } else if (val == 'UNIFORM_AUDIT_NO_PASS') {
    return '终审未通过'
  } else if (val == 'UNIFORM_AUDIT_OFFLINE') {
    return '终审下线'
  }
})
Vue.filter('auditStyle', function (val) {
  if (val == 'AUDIT_EXEMPT') {
    return 'green'
  } else if (val == 'AUDIT_NON') {
    return 'blue'
  } else if (val == 'AUDIT_ING') {
    return 'orange'
  } else if (val == 'AUDIT_PASS') {
    return 'green'
  } else if (val == 'AUDIT_NO_PASS') {
    return 'red'
  } else if (val == 'RE_AUDIT_ING') {
    return 'orange'
  } else if (val == 'RE_AUDIT_NO_PASS') {
    return 'red'
  } else if (val == 'UNIFORM_AUDIT_NON') {
    return 'blue'
  } else if (val == 'UNIFORM_AUDIT_ING') {
    return 'orange'
  } else if (val == 'UNIFORM_AUDIT_PASS') {
    return 'green'
  } else if (val == 'UNIFORM_AUDIT_NO_PASS') {
    return 'red'
  } else if (val == 'UNIFORM_AUDIT_OFFLINE') {
    return ''
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
